;(function () {
  if (window._video_shopping_loaded) {
    return
  } else {
    const PlayerEvents = window.Player.Events
    // 全局视频控制器 - 确保整个页面只有一个视频在播放
    class VideoController {
      static instances = [] // 存储所有视频画廊实例
      static activeGallery = null // 当前正在播放视频的画廊

      // 注册视频画廊实例
      static registerGallery(gallery) {
        VideoController.instances.push(gallery)
      }

      // 设置当前活动的画廊，并暂停其他画廊中的视频
      static setActiveGallery(gallery) {
        // 如果已经是活动画廊，不做任何操作
        if (VideoController.activeGallery === gallery) return

        // 暂停其他所有画廊中的视频
        VideoController.instances.forEach((instance) => {
          if (instance !== gallery) {
            instance.pauseAllVideos()
          }
        })

        // 设置当前活动画廊
        VideoController.activeGallery = gallery
      }
    }

    // 创建视频画廊类来管理每个画廊的状态和行为
    class ModalController {
      static instance = null
      static videoModal = null
      constructor() {
        if (ModalController.instance) {
          return ModalController.instance
        }

        this.modalPlayer = null
        this.currentGallery = null
        this.modalPlayIndex = 0
        this.lastTime = 0

        this.createVideoModal() // 创建视频弹窗
        // 初始化弹窗事件监听
        this.initModalEvents()

        ModalController.instance = this
      }

      createVideoModal() {
        // 创建视频弹窗
        const videoModal = document.createElement('div')
        videoModal.id = 'videoModal'
        videoModal.className = 'video-modal video-shopping-drawer'
        videoModal.style.setProperty('--swiper-navigation-top-offset', '50%')
        videoModal.style.setProperty('--swiper-navigation-color', '#ffffff')
        videoModal.style.setProperty('--swiper-navigation-size', '20px')
        videoModal.style.setProperty('--swiper-navigation-sides-offset', '15px')
        videoModal.innerHTML = `
        <div class="modal-header">
          <div class="modal-title" id="modalTitle">Video Title</div>
          <div class="modal-controls">
            <button class="modal-control-btn" id="closeModal">✕</button>
            <button class="modal-control-btn" id="backToPipBtn" title="Back to PIP">⧉</button>
          </div>
        </div>
        <div class="modal-video-container" id="modalVideoContainer"></div>
        <div class="modal-products-wrapper">
          <div id="modalProduct" class="modal-products">
            <div class="product-list" id="productList">
              <!-- 产品列表将由JavaScript动态填充 -->
            </div>
          </div>
        </div>
        <div class="video-button-prev swiper-button-prev swiper-button-disabled"></div>
        <div class="video-button-next swiper-button-next"></div>
        `
        // 赋值
        this.videoModal = videoModal
        // 将弹窗添加到页面
        document.body.appendChild(videoModal)
      }

      initModalEvents() {
        if (this.videoModal) {
          const closeModal = this.videoModal.querySelector('#closeModal')
          const prevBtn = this.videoModal.querySelector('.video-button-prev')
          const nextBtn = this.videoModal.querySelector('.video-button-next')
          const backToPipBtn = this.videoModal.querySelector('#backToPipBtn')

          closeModal && closeModal.addEventListener('click', () => this.closeModal())
          prevBtn && prevBtn.addEventListener('click', () => this.playPrevModalVideo())
          nextBtn && nextBtn.addEventListener('click', () => this.playNextModalVideo())
          backToPipBtn && backToPipBtn.addEventListener('click', () => this.switchToPip())
        }
      }

      openModal(video, gallery, openModal = true, startTime = 0) {
        this.currentGallery = gallery
        const modalTitle = this.videoModal.querySelector('#modalTitle')
        const modalVideoContainer = this.videoModal.querySelector('#modalVideoContainer')
        const productList = this.videoModal.querySelector('#productList')
        const modalProduct = this.videoModal.querySelector('#modalProduct')
        if (video.products && video.products.length > 0) {
          this.videoModal.classList.remove('no-product')
        } else {
          this.videoModal.classList.add('no-product')
        }
        const matchVideoIndex = gallery.videos.findIndex((v) => v.id === video.id)
        if (matchVideoIndex !== -1) {
          this.modalPlayIndex = matchVideoIndex
        }
        this.lastTime = startTime || 0

        // 设置视频标题
        modalTitle.textContent = video.title

        // 暂停当前所有视频
        VideoController.instances.forEach((instance) => {
          instance.pauseAllVideos()
        })

        // 移除已有的播放器（如果存在）
        modalVideoContainer.innerHTML = ''

        // 创建播放器容器
        const playerContainer = document.createElement('div')
        playerContainer.id = `modal-player-${video.id}`
        modalVideoContainer.appendChild(playerContainer)

        // 创建弹窗播放器实例
        this.modalPlayer = new window.Player({
          id: `modal-player-${video.id}`,
          url: video.url,
          poster: video.thumbnail,
          plugins: [Mp4Plugin],
          controls: {
            autoHide: false,
            mode: 'bottom'
          },
          autoplay: true,
          fluid: true,
          width: 900,
          height: 1600,
          fitVideoSize: 'fixed',
          videoFillMode: 'contain',
          lang: 'en',
          loop: false,
          muted: true,
          marginControls: false,
          ignores: ['fullscreen', 'cssfullscreen', 'playbackrate']
        })

        // 跳转到指定时间
        this.modalPlayer.on('ready', () => {
          if (this.lastTime > 0) {
            this.modalPlayer.currentTime = this.lastTime
          }
          this.modalPlayer.play()
        })

        // 调用接口注册插件
        this.modalPlayer.registerPlugin(window.videoshoppingRelativeProduct)

        /** @typedef {object} VideoProductItem
         * @property {string} mkt_sku
         * @property {string} image
         * @property {null} sleeve_img_filepath
         * @property {string} product_type
         * @property {number} price
         * @property {number} compare_at_price
         * @property {string} title
         * @property {string} handle
         * @property {number} variant_id
         * @property {number} product_id
         * @property {string} sellable
         * @property {number} inventory_quantity
         * @property {number} domestic_inventory_quantity
         * @property {} properties
         * @property {number} show_up_time
         * @property {number} index
         */
        /** @type {VideoProductItem[]} */
        const products = video.products.map((item, index) => {
          const nextProduct = video.products[index + 1]
          const nextTimeValue = nextProduct ? nextProduct.show_up_time : null
          return {
            name: item.title,
            variant: '',
            price: item.price,
            originalPrice: item.compare_at_price,
            image: item.image,
            timeRange: {
              start: item.show_up_time,
              end: nextTimeValue
            },
            // add aff_id to product
            aff_id: video.aff_id,
            variant_id: item.variant_id,
            handle: item.handle
          }
        })

        // 添加产品属性
        this.modalPlayer.products = products || []

        // 填充产品列表
        productList.innerHTML = ''
        if (this.modalPlayer.products.length === 0) {
          modalProduct.classList.add('hidden')
        } else {
          modalProduct.classList.remove('hidden')
          this.modalPlayer.getPlugin('videoshoppingRelativeProduct').insertProductData(productList, modalProduct)
          this.modalPlayer.getPlugin('videoshoppingRelativeProduct').queryCouponCodeAndUpdateCoupon()
        }
        if (openModal) {
          setTimeout(() => {
            this.videoModal.classList.add('active')
            document.body.style.overflow = 'hidden'
          }, 0)
        }

        this.modalPlayer.on(PlayerEvents.ENDED, () => {
          if (this.modalPlayer.currentTime >= this.modalPlayer.duration) {
            this.playNextModalVideo()
          }
        })
        this.updateNavigationButtons()
      }

      closeModal() {
        if (this.modalPlayer) {
          if (window.__PipController) {
            const video = this.currentGallery && this.currentGallery.videos[this.modalPlayIndex]
            if (video) {
              const currentTime = this.modalPlayer.currentTime || 0
              window.__PipController.show(video, currentTime)
            }
          }

          this.modalPlayer.unRegisterPlugin('videoshoppingRelativeProduct')
          this.modalPlayer.destroy()
          this.modalPlayer = null
        }

        this.videoModal.classList.remove('active')
        document.body.style.overflow = ''
      }

      playNextModalVideo() {
        if (!this.currentGallery || !this.modalPlayer) return

        if (this.modalPlayer) {
          this.modalPlayer.off(PlayerEvents.ENDED)
          this.modalPlayer.off(PlayerEvents.TIME_UPDATE)
        }

        if (this.modalPlayIndex < this.currentGallery.videos.length - 1) {
          this.modalPlayIndex++
          this.openModal(this.currentGallery.videos[this.modalPlayIndex], this.currentGallery, false)
          this.updateNavigationButtons()
        }
      }

      playPrevModalVideo() {
        if (!this.currentGallery || !this.modalPlayer) return

        if (this.modalPlayer) {
          this.modalPlayer.off(PlayerEvents.ENDED)
          this.modalPlayer.off(PlayerEvents.TIME_UPDATE)
        }

        if (this.modalPlayIndex > 0) {
          this.modalPlayIndex--
          this.openModal(this.currentGallery.videos[this.modalPlayIndex], this.currentGallery, false)
          this.updateNavigationButtons()
        }
      }

      updateNavigationButtons() {
        const prevBtn = this.videoModal.querySelector('.video-button-prev')
        const nextBtn = this.videoModal.querySelector('.video-button-next')

        if (this.modalPlayIndex === 0) {
          prevBtn.classList.add('swiper-button-disabled')
        } else {
          prevBtn.classList.remove('swiper-button-disabled')
        }

        if (this.modalPlayIndex === this.currentGallery.videos.length - 1) {
          nextBtn.classList.add('swiper-button-disabled')
        } else {
          nextBtn.classList.remove('swiper-button-disabled')
        }
      }

      switchToPip() {
        // 切换回画中画
        this.closeModal()
      }
    }

    class VideoGallery {
      constructor(containerId, videos, displayVideoList) {
        this.container = document.getElementById(containerId)
        this.videos = videos
        this.players = {} // 存储所有播放器实例
        this.activePlayer = null // 当前活动的播放器
        this.currentPosition = 0 // 当前列表播放索引
        this.showVideoList = displayVideoList

        this.modalController = new ModalController() // 使用单例模式的 ModalController
        // 将此实例注册到全局控制器
        VideoController.registerGallery(this)
        if (displayVideoList) {
          // 初始化
          this.init()
        } else {
          VideoController.setActiveGallery(this)
        }

        // 页面加载完成后初始化画中画功能
        initPictureInPictureForVideoShopping()
      }

      // 初始化画廊
      init() {
        // 初始化轮播
        setTimeout(() => {
          this.initializeCarousel()
        }, 1500)

        // 监听窗口大小变化
        window.addEventListener('resize', () => {
          this.updateCarousel()
        })
      }

      // 初始化轮播
      initializeCarousel() {
        const skeletonCarousel = this.container.querySelector('.skeleton-carousel')

        // 清除骨架屏
        skeletonCarousel.innerHTML = ''
        // 渲染视频卡片
        this.videos.forEach((video, index) => {
          const carouselItem = document.createElement('div')
          carouselItem.className = 'swiper-slide'
          carouselItem.setAttribute('data-video-id', video.id)
          carouselItem.innerHTML = `
              <div class="video-card">
                <div class="video-container">
                  <div id="player-${video.id}" class="video-player"></div>
                  <div class="video-title">${video.title}</div>
                  <div class="video-play-icon"></div>
                  <div class="video-shopping-icon">
                    <svg t="1741769057053" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21695" width="64" height="64"><path d="M943.12 803.936L870.944 320H736v80h65.984L864 815.744a55.2 55.2 0 0 1-12.96 44.816A55.216 55.216 0 0 1 808.608 880H199.36a55.216 55.216 0 0 1-42.4-19.44A55.216 55.216 0 0 1 144 815.728L206.016 400H416V232c0-48.528 39.472-88 88-88s88 39.472 88 88V320h-112v80h192V232C672 139.36 596.64 64 504 64S336 139.36 336 232V320H137.056L64.88 803.936a135.904 135.904 0 0 0 31.488 108.848A135.888 135.888 0 0 0 199.376 960H808.64a135.888 135.888 0 0 0 103.008-47.2 135.888 135.888 0 0 0 31.488-108.864zM336 504a40 40 0 1 0 80 0 40 40 0 0 0-80 0z m256 0a40 40 0 1 0 80 0 40 40 0 0 0-80 0z" fill="#ffffff" p-id="21696"></path></svg>
                  </div>
                </div>
              </div>
              `

          skeletonCarousel.appendChild(carouselItem)

          // 缓存this引用
          const self = this
          this.swiper = new Swiper(this.container, {
            // Optional parameters
            slidesPerView: 2,
            spaceBetween: 10,
            breakpoints: {
              // when window width is >= 320px
              480: {
                slidesPerView: 2,
                spaceBetween: 20
              },
              // when window width is >= 480px
              768: {
                slidesPerView: 3,
                spaceBetween: 20
              },
              // when window width is >= 640px
              992: {
                slidesPerView: 4,
                spaceBetween: 20
              },
              // when window width is >= 1200px
              1200: {
                slidesPerView: 5,
                spaceBetween: 20
              },
              // when window width is >= 1400px
              1400: {
                slidesPerView: 7,
                spaceBetween: 20
              }
            },
            // Navigation arrows
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            on: {
              slideChange: function () {
                self.currentPosition = this.realIndex
                self.updateCarousel()
              }
            }
          })

          // 初始化播放器 (但不显示)
          this.initializePlayer(video, index === 0)

          if (matchMedia('(max-width: 1024px)').matches) {
            // 也支持点击事件，确保在移动设备上的浏览器也能正常工作
            carouselItem.addEventListener('click', function () {
              self.openVideoModal(video)
            })
          } else {
            // PC端鼠标悬停事件
            carouselItem.addEventListener('mouseenter', function () {
              self.playVideo(video.id)
            })
            carouselItem.addEventListener('click', function () {
              self.openVideoModal(video)
            })
          }

          // 添加购物图标点击事件
          const shoppingIcon = carouselItem.querySelector('.video-shopping-icon')
          shoppingIcon.addEventListener('click', function (e) {
            e.stopPropagation() // 阻止冒泡，防止触发卡片的点击事件
            self.openVideoModal(video)
          })
        })

        // 初始化轮播位置
        this.updateCarousel()
      }

      // 初始化单个播放器
      initializePlayer(video, isFirst) {
        // 使用xgplayer初始化播放器
        const player = new window.Player({
          id: `player-${video.id}`,
          url: video.url,
          poster: video.thumbnail,
          autoplay: false,
          closeVideoClick: true,
          closeVideoDblclick: true,
          plugins: [Mp4Plugin],
          volume: 0,
          height: '100%',
          fluid: true,
          lang: 'en',
          loop: false,
          controls: false, // 不显示控制栏
          muted: true // 默认静音
        })

        // 存储播放器实例
        this.players[video.id] = player
      }

      // 更新轮播位置和按钮状态
      updateCarousel() {
        // 如果第一个视频在视图中，自动播放它
        if (
          typeof this.currentPosition === 'number' &&
          this.currentPosition >= 0 &&
          this.videos[this.currentPosition]
        ) {
          this.playVideo(this.videos[this.currentPosition].id, true)
        }
      }

      // 播放视频
      playVideo(videoId, muted = false) {
        // 通知全局控制器这个画廊将要播放视频
        VideoController.setActiveGallery(this)
        // 将当前画廊的所有视频都先暂停
        this.pauseAllVideos()
        // 播放当前视频
        const player = this.players[videoId]

        if (player) {
          player.muted = muted
          player.play()
          this.activePlayer = player
          // 监听播放结束事件

          player.on(PlayerEvents.ENDED, () => {
            this.swiper.slideNext()
          })
        }
      }

      // 暂停所有视频
      pauseAllVideos() {
        for (const id in this.players) {
          this.players[id].pause()
        }
        this.activePlayer = null
      }

      // 打开视频弹窗
      openVideoModal(video, startTime = 0) {
        window.__PipController.hide()
        this.modalController.openModal(video, this, true, startTime)
      }
    }

    // 画中画控制器
    class PictureInPictureController {
      static instance = null

      constructor() {
        if (PictureInPictureController.instance) {
          return PictureInPictureController.instance
        }

        this.pipContainer = null
        this.pipPlayer = null
        this.currentVideo = null
        this.isVisible = false
        this.lastTime = 0

        this.createPictureInPicture()
        this.initEvents()

        PictureInPictureController.instance = this
      }

      createPictureInPicture() {
        // 创建画中画容器
        this.pipContainer = document.createElement('div')
        this.pipContainer.id = 'picture-in-picture-container'
        this.pipContainer.className = 'picture-in-picture-container'
        this.pipContainer.innerHTML = `
          <div class="pip-video-wrapper">
            <div id="pip-player" class="pip-player"></div>
            <div class="pip-controls">
              <button class="pip-close-btn" id="pipCloseBtn">✕</button>
            </div>
          </div>
        `

        // 添加样式
        this.addStyles()

        // 添加到页面
        document.body.appendChild(this.pipContainer)
      }

      addStyles() {
        const style = document.createElement('style')
        style.textContent = `
          .picture-in-picture-container {
            position: fixed;
            bottom: 16px;
            left: 16px;
            z-index: 9999;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
            background: #000;
            opacity: 0;
            transform: translateY(100%);
            transition: all 0.3s ease;
            pointer-events: none;
          }

          .picture-in-picture-container.visible {
            opacity: 1;
            transform: translateY(0);
            pointer-events: auto;
          }

          .picture-in-picture-container .pip-video-wrapper {
            position: relative;
            width: 105px;
            height: 186px;
            overflow: hidden;
          }

          .picture-in-picture-container .pip-player {
            width: 100%;
            height: 100%;
          }

          .picture-in-picture-container .pip-controls {
            position: absolute;
            top: 4px;
            right: 4px;
            display: flex;
            gap: 4px;
            opacity: 1;
            transition: opacity 0.2s ease;
          }

          .picture-in-picture-container .pip-controls button {
            width: 24px;
            height: 24px;
            border: none;
            background: rgba(0, 0, 0, 0.9);
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            cursor: pointer;
            transition: background 0.2s ease;
          }


          /* PC端样式 */
          @media (min-width: 769px) {
            .picture-in-picture-container .pip-video-wrapper {
              width: 120px;
              height: 213px;
            }

            .picture-in-picture-container .pip-controls button {
              width: 24px;
              height: 24px;
              font-size: 12px;
            }
          }

          /* 隐藏xgplayer的控制栏 */
          .picture-in-picture-container .xgplayer-controls {
            display: none !important;
          }

          .picture-in-picture-container .xgplayer-start {
            display: none !important;
          }
        `
        document.head.appendChild(style)
      }

      initEvents() {
        const closeBtn = this.pipContainer.querySelector('#pipCloseBtn')

        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation()
          this.hide()
        })

        // 点击画中画容器，打开弹窗
        this.pipContainer.addEventListener('click', (e) => {
          e.stopPropagation()
          if (this.currentVideo) {
            // 获取当前pip播放进度
            let pipTime = 0
            if (this.pipPlayer && typeof this.pipPlayer.currentTime === 'number') {
              pipTime = this.pipPlayer.currentTime
            }
            // 使用现有的弹窗功能，传递播放进度
            const activeGallery = window.__VideoController.activeGallery
            if (activeGallery) {
              activeGallery.openVideoModal(this.currentVideo, pipTime)
            }
            // 隐藏并暂停pip
            this.hide()
          }
        })
      }

      show(video, startTime = 0) {
        if (!video) return

        this.currentVideo = video
        this.lastTime = startTime || 0

        // 如果已经有播放器，先销毁
        if (this.pipPlayer) {
          this.pipPlayer.destroy()
        }

        // 创建新的播放器
        setTimeout(() => {
          this.pipPlayer = new window.Player({
            id: 'pip-player',
            url: video.url,
            poster: video.thumbnail,
            plugins: [Mp4Plugin],
            closeVideoClick: true,
            closeVideoDblclick: true,
            autoplay: true,
            volume: 0,
            width: 900,
            height: 1600,
            fluid: true,
            lang: 'en',
            loop: true,
            controls: false,
            muted: true,
            fitVideoSize: 'cover'
          })
          // 跳转到指定时间
          this.pipPlayer.on('ready', () => {
            if (this.lastTime > 0) {
              this.pipPlayer.currentTime = this.lastTime
            }
            this.pipPlayer.play()
          })
        }, 100)

        // 显示画中画
        this.pipContainer.classList.add('visible')
        this.isVisible = true
      }

      hide() {
        this.pipContainer.classList.remove('visible')
        this.isVisible = false

        if (this.pipPlayer) {
          this.pipPlayer.pause()
        }
      }

      updateVideo(video) {
        if (this.isVisible && video) {
          this.show(video)
        }
      }
    }

    // 检测页面是否已有视频购物画廊并初始化画中画
    function initPictureInPictureForVideoShopping() {
      const allVideos = []
      VideoController.instances.forEach((instance) => {
        allVideos.push(...instance.videos)
      })

      if (allVideos.length > 0) {
        const pipController = new PictureInPictureController()

        // 监听视频切换
        const originalPlayVideo = VideoGallery.prototype.playVideo
        VideoGallery.prototype.playVideo = function (videoId, muted = false) {
          const result = originalPlayVideo.call(this, videoId, muted)

          // 更新画中画显示的视频
          const currentVideo = this.videos.find((v) => v.id === videoId)
          if (currentVideo && pipController.isVisible) {
            pipController.updateVideo(currentVideo)
          }

          return result
        }

        // 存储画中画控制器到全局
        window.__PipController = pipController
        pipController.show(allVideos[0])
      }
    }

    window._video_shopping_loaded = true
    window.__VideoController = VideoController
    window.__ModalController = ModalController
    window.__VideoGallery = VideoGallery
    window.__PictureInPictureController = PictureInPictureController
  }
})()
